<template>
  <section id="maintenance" class="maintenance-area pt-100 pb-70">
    <div class="container">

      <!-- Cabecera -->
      <div class="one-section-title text-center">
        <span class="sub-title">{{ $t('ads.subTitle') }}</span>
        <h2>{{ $t('ads.title') }}</h2>
        <p class="lead">
          {{ $t('ads.desc') }}
        </p>
      </div>

      <!-- Beneficios -->
      <div class="row g-4 benefits">
        <div class="col-sm-6 col-lg-4" v-for="(b, i) in benefits" :key="i">
          <div class="benefit-card">
            <i :class="b.icon"></i>
            <h4>{{ $t(b.title) }}</h4>
            <p>{{ $t(b.text) }}</p>
          </div>
        </div>
      </div>

      <!-- Condiciones -->
      <div class="accordion">
        <h3 class="text-center mb-3">{{ $t('ads.conditionsTitle') }}</h3>

        <details v-for="(cond, i) in conditions" :key="i">
          <summary>{{ $t(cond.title) }}</summary>
          <div class="acc-body" v-html="$t(cond.content)"></div>
        </details>
      </div>

      <!-- CTA -->
      <div class="cta-wrap">
        <a class="cmn-banner-btn" href="tel:+34634061655">
          <i class='bx bx-phone'></i> {{ $t('ads.ctaCall') }}
        </a>
        <a class="banner-right-btn" href="#contact-strip">
          <i class='bx bx-send'></i> {{ $t('ads.ctaQuote') }}
        </a>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: 'MaintenancePlan',
  data() {
    return {
      benefits: [
        { icon: 'bx bx-bullseye', title: 'ads.benefits.b1.title', text: 'ads.benefits.b1.text' },
        { icon: 'bx bx-line-chart', title: 'ads.benefits.b2.title', text: 'ads.benefits.b2.text' },
        { icon: 'bx bx-world', title: 'ads.benefits.b3.title', text: 'ads.benefits.b3.text' },
        { icon: 'bx bx-support', title: 'ads.benefits.b4.title', text: 'ads.benefits.b4.text' },
        { icon: 'bx bx-car', title: 'ads.benefits.b5.title', text: 'ads.benefits.b5.text' },
        { icon: 'bx bx-map', title: 'ads.benefits.b6.title', text: 'ads.benefits.b6.text' }
      ],
      conditions: [
        { title: 'ads.conditions.c1.title', content: 'ads.conditions.c1.text' },
        { title: 'ads.conditions.c2.title', content: 'ads.conditions.c2.text' },
        { title: 'ads.conditions.c3.title', content: 'ads.conditions.c3.text' },
        { title: 'ads.conditions.c4.title', content: 'ads.conditions.c4.text' },
        { title: 'ads.conditions.c5.title', content: 'ads.conditions.c5.text' }
      ]
    };
  }
};
</script>



<style scoped>
:root {
    --main-color: #ff8a00;
}

.maintenance-area {
    position: relative;
    background: #2f0f34 url('@/assets/img/resources/address-bg.png') no-repeat center center;
    background-size: cover;
    color: #fff;
    z-index: 1;
}

.maintenance-area::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(15, 15, 16, 0.45);
    z-index: -1;
}

/* Cabecera */
.one-section-title .sub-title {
    color: #ffc48a;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-weight: 700;
    margin-bottom: 8px;
}

.one-section-title h2 {
    color: #fff;
    font-weight: 800;
    margin-bottom: 10px;
}

.maintenance-area .lead {
    max-width: 920px;
    margin: 0 auto 20px;
    color: #d4d6db;
}

/* Beneficios */
.benefit-card {
    background: rgba(26, 26, 29, 0.95);
    border: 1px solid #2a2a2f;
    border-radius: 12px;
    padding: 22px;
    height: 100%;
    color: #eee;
    text-align: left;
    transition: 0.25s ease;
    box-shadow: 0 6px 18px rgba(0, 0, 0, .25);
}

.benefit-card:hover {
    border-color: var(--main-color);
    transform: translateY(-3px);
}

.benefit-card i {
    font-size: 30px;
    color: var(--main-color);
    margin-bottom: 8px;
}

.benefit-card h4 {
    margin-bottom: 6px;
    color: #fff;
    font-weight: 700;
}

.benefit-card p {
    color: #ccc;
    margin: 0;
}

/* CTA */
.cta-wrap {
    display: flex;
    gap: 14px;
    justify-content: center;
    margin: 28px 0 18px;
    flex-wrap: wrap;
}

.cmn-banner-btn,
.banner-right-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 12px 20px;
    border-radius: 10px;
    font-weight: 700;
    transition: all 0.3s ease;
}

.cmn-banner-btn {
    background: var(--main-color);
    color: #0f0f10;
    box-shadow: 0 6px 18px rgba(255, 138, 0, 0.3);
}

.cmn-banner-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 10px 24px rgba(255, 138, 0, 0.4);
}

.banner-right-btn {
    border: 1px solid #444;
    background: rgba(26, 26, 29, 0.85);
    color: #fff;
}

.banner-right-btn:hover {
    border-color: var(--main-color);
    color: #fff;
}

/* Accordion */
.accordion {
    max-width: 980px;
    margin: 24px auto 0;
}

.accordion h3 {
    color: #fff;
    font-weight: 800;
}

.accordion details {
    background: rgba(18, 18, 20, 0.9);
    border: 1px solid #2a2a2f;
    border-radius: 10px;
    margin-bottom: 10px;
    transition: all 0.3s ease;
}

.accordion details[open] {
    border-color: var(--main-color);
}

.accordion summary {
    cursor: pointer;
    list-style: none;
    padding: 16px 18px;
    font-weight: 700;
    color: #fff;
    position: relative;
}

.accordion summary::after {
    content: '+';
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--main-color);
    font-weight: 900;
}

.accordion details[open] summary::after {
    content: '–';
}

.acc-body {
    padding: 0 18px 16px;
    color: #ddd;
    line-height: 1.65;
}

.acc-body ul {
    padding-left: 18px;
    margin: 0;
}

/* Responsive */
@media (max-width: 767px) {
    .benefit-card {
        text-align: center;
    }

    .acc-body {
        font-size: 15px;
    }
}
</style>
